(function ($) {
	$.fn.toc = function () {
		let $el;
		let $thresholds;
		let $anchors;
		let $trigger;

		const init = function () {
			$(document).ready(function () {
				enableFloating();

				refreshTop();
				refreshThresholds();
				refreshTrigger();

				buildList();

				trackProgress();

				$(window).resize(function () {
					refreshTop();
					refreshThresholds();
					refreshTrigger();
				});

				$(window).scroll(function () {
					refreshTrigger();
					trackProgress();
				});

				// Scroll to an anchor has been moved to main.js
			});
		};

		const enableFloating = function () {
			$el.addClass('is-floating');
		};

		const refreshTop = function () {
			$el.css(
				'top',
				parseInt($el.parent().css('padding-top')) +
					$(window).height() / 2
			);
		};

		const refreshTrigger = function () {
			$trigger = $(window).scrollTop();
		};

		const buildList = function () {
			$el.find('li').each(function (index, element) {
				setTimeout(function () {
					$(element).addClass('is-animated');
				}, 250 * index);
			});
		};

		const refreshThresholds = function () {
			$anchors = $('.page-anchor');
			$thresholds = [];

			if ($anchors.length > 0) {
				$anchors.each(function (k, el) {
					$thresholds.push($(el).offset().top);
				});
			}
		};

		const trackProgress = function () {
			if ($thresholds.length > 0) {
				// If above all the anchors, then stop.
				if ($trigger < $thresholds[0]) {
					$.each($thresholds, function (i) {
						setProgress(i, '0');
					});
					return;
				}

				$.each($thresholds, function (i, t) {
					const bottom =
						$anchors.eq(i).next().offset().top +
						$anchors.eq(i).next().outerHeight();

					// Each section that comes before, set to 100%
					if ($trigger < t) {
						setProgress(i, 0);
					}

					// If hovering a section.
					if ($trigger >= t && $trigger <= bottom) {
						// Set the current progress
						const progress =
							(($trigger - t) /
								$anchors.eq(i).next().outerHeight()) *
							100;
						setProgress(i, progress);
					}

					// Passed all the sections.
					if ($trigger > bottom) {
						setProgress(i, 100);
					}
				});
			}
		};

		const setProgress = function (index, number) {
			const item = $el.find('li').eq(index);
			if (number > 0) {
				item.addClass('is-active');
			} else {
				item.removeClass('is-active');
			}
			item.css('--scroll-progress', number + '%');
		};

		if (this.length > 0) {
			if (this.length > 1) {
				this.each(function () {
					$(this).toc();
				});
			} else {
				$el = this;
				init();
			}
		}
	};
})(jQuery);
